<template>
  <v-container fluid style="height: 100vh; overflow: hidden; padding: 0">
    <!-- Fixed form row -->
    <v-row
      no-gutters
      align="start"
      style="
        position: fixed;
        top: 104px;
        left: 0;
        right: 0;
        background: white;
        z-index: 10;
        padding: 16px;
      "
    >
      <v-col cols="12" sm="4" style="padding: 8px; z-index: 20">
        <v-badge overlap bordered color="secondary" style="width: 100%">
          <template v-slot:badge>{{ indexSize }}</template>
          <v-text-field
            v-model="searchQuery"
            solo
            clearable
            label="Search Text"
            messages="Start typing"
            prepend-inner-icon="mdi-magnify"
            @input="onInputDebounced"
          />
        </v-badge>
      </v-col>

      <v-col cols="12" sm="8" style="padding: 8px">
        <v-autocomplete
          chips
          clearable
          deletable-chips
          multiple
          solo
          auto-select-first
          hide-selected
          messages="Start typing or click drop down"
          menu-props="closeOnContentClick"
          prepend-inner-icon="mdi-filter-variant"
          label="Select Types"
          v-model="typeFilter"
          :items="typesMap"
          item-text="name"
          item-value="value"
        />
      </v-col>
    </v-row>

    <!-- Spacer to offset the fixed form height -->
    <div style="height: 112px"></div>

    <!-- Scrollable results -->
    <div style="overflow-y: auto; height: calc(100vh - 160px); padding: 16px">
      <v-alert v-if="!ids.length" color="secondary" type="info">
        The view is empty
      </v-alert>

      <v-row no-gutters>
        <individual-list :ids="ids" :highlights="queryStrings" />
      </v-row>
    </div>
  </v-container>
</template>

<script>
import IndividualList from '@/components/IndividualList.vue'

import debounce from 'debounce'

export default {
  components: { IndividualList },
  data: () => ({
    searchQuery: '',
    typeFilter: [],
    typesMap: [],
    // TODO the selection doesnt seem to be used. Refactor.
    selection: { ids: [] },
  }),
  mounted() {
    // this.selection = this.$wob.indexSelector.createSelection()
    // console.log('components.individual-search.mounted', this.$wob.index.ids)
    this.searchQuery = this.$store.getters.getQuery
    this.typeFilter = this.$store.getters.getTypeQuery
    this.$wob.types.query(this.typeFilter)

    // Calculate types map and set filter according to query filter.
    // TODO refactor, place in method, also used in watchers.
    this.typesMap = this.types
      .map((t) => {
        return { name: t.split('#').pop().split('/').pop(), value: t }
      })
      .sort(({ name: n1 }, { name: n2 }) => n1.localeCompare(n2))
    // Remove values from the filter if disappeared from types map,
    // eg when last individual of a given type is deleted.
    this.typeFilter = this.typeFilter.filter((t) =>
      this.typesMap.map((e) => e.value).includes(t)
    )
    this.$store.commit('setTypeQuery', this.typeFilter)

    console.log('views.search-view.mounted', this.searchQuery, this.typeQuery)

    // TODO refactor, remove below, but the query on the index must be run here instead...
    this.updateSelection()
  },

  computed: {
    indexSize: function () {
      return this.ids.length
    },
    queryStrings: function () {
      return this.searchQuery?.split(' ').filter((s) => !!s) || []
    },
    ids: function () {
      // Intersect through a Set. Array.includes inside filter is O(n x m), and
      // with no type filter selected both lists hold every id in the cache —
      // ~46k x ~46k on the Fabege graph, on the order of a billion string
      // comparisons, re-run whenever either list changes.
      const indexIds = this.$wob.index.ids
      const typeIds = new Set(this.$wob.types.ids)
      return indexIds.filter((i) => typeIds.has(i))
    },
    types: function () {
      return this.$wob.types.list
    },
    exceptions: function () {
      // `exceptions` is no longer created by the plugin (commented out in
      // vue-wob-cache.js); reading .ids on it threw.
      return this.$wob.exceptions?.ids ?? []
    },
  },
  watch: {
    typeFilter: function (newFilter) {
      this.$store.commit('setTypeQuery', newFilter)
      this.$wob.types.query(newFilter)
    },
    types: async function (newTypes) {
      this.typesMap = newTypes
        .map((t) => {
          return { name: t.split('#').pop().split('/').pop(), value: t }
        })
        .sort(({ name: n1 }, { name: n2 }) => n1.localeCompare(n2))

      // Remove values from the filter if disappeared from value map.
      this.typeFilter = this.typeFilter.filter((t) =>
        this.typesMap.map((e) => e.value).includes(t)
      )
      this.$store.commit('setTypeQuery', this.typeFilter)
    },
  },
  methods: {
    onInputDebounced: debounce(function () {
      console.log(
        'components.individual-search.methods.on-input-debounced',
        this.searchQuery
      )
      this.updateSelection()
      this.$store.commit('setQuery', this.searchQuery)
    }, 200),

    // TODO deprecated input event handler...
    onInput: function () {
      console.log(
        'components.individual-search.methods.on-input',
        this.searchQuery
      )
      this.updateSelection()
      this.$store.commit('setQuery', this.searchQuery)
    },

    updateSelection: function () {
      console.log(
        'components.individual-search.methods.update-selection',
        this.searchQuery,
        this.typeQuery
      )
      this.selection = this.$wob.index.query(this.searchQuery)
    },
  },
}
</script>
